import databaseAPI from '../../api/databaseAPI.js';

export default function DisputeManagementPanel({ orders, onResolveDispute }) {
  const disputed = orders.filter((order) => order.dispute_data);

  return (
    <div className="dispute-management-container">
      <div className="dispute-management-header">
        <h3>Dispute Management</h3>
        <p>View and manage all order disputes</p>
      </div>

      <div className="disputes-list">
        {disputed.length === 0 ? (
          <div className="no-disputes">
            <p>✅ No disputes found! All orders are running smoothly.</p>
          </div>
        ) : (
          <div className="disputes-grid dispute-rows">
            {disputed.map((order) => (
              <div key={order.id} className="dispute-card dispute-row-card">
                <div className="dispute-row-main">
                  <div className="dispute-row-col order-col">
                    <div className="order-id">Order {order.name}</div>
                    <div className="customer-info">{order.email}</div>
                  </div>
                  <div className="dispute-row-col issue-col">
                    <div className="dispute-row-label">Issue</div>
                    <div className="issue-type">{order.dispute_data.reason?.replace('_', ' ')}</div>
                  </div>
                  <div className="dispute-row-col comment-col">
                    <div className="dispute-row-label">Description</div>
                    <div className="dispute-row-comment">{order.dispute_data.comment || '—'}</div>
                  </div>
                  <div className="dispute-row-col dates-col">
                    <div className="dispute-date">
                      {new Date(order.dispute_data.created_at).toLocaleDateString()}
                    </div>
                    {order.dispute_data.resolved_at && (
                      <div className="resolution-date">
                        Resolved: {new Date(order.dispute_data.resolved_at).toLocaleDateString()}
                      </div>
                    )}
                  </div>
                  <div className="dispute-row-col status-col">
                    <span className={`status-indicator ${order.dispute_data.status}`}>
                      {order.dispute_data.status === 'pending' ? 'Pending' : 'Resolved'}
                    </span>
                  </div>
                </div>

                <div className="dispute-row-extra">
                  {((order.dispute_data.photos && order.dispute_data.photos.length > 0)
                    || (order.dispute_data.photo_count > 0 && !order.dispute_data.photos?.length)) && (
                    <div className="dispute-photos-inline">
                      {(order.dispute_data.photos || []).map((photo, index) => (
                        <span
                          key={index}
                          className="photo-link"
                          onClick={() => {
                            const base = databaseAPI.baseURL || 'https://shopbackend.artstoheartsproject.com/api';
                            window.open(`${base}/dispute-images/${photo}/`, '_blank');
                          }}
                          title="Click to view image"
                        >
                          {photo}
                        </span>
                      ))}
                    </div>
                  )}

                  {order.dispute_data.status === 'resolved' && order.dispute_data.resolution_type && (
                    <span className={`resolution-type ${order.dispute_data.resolution_type}`}>
                      {order.dispute_data.resolution_type === 'refund' ? 'Refund Processed' : 'Replacement Approved'}
                    </span>
                  )}

                  {order.dispute_data.status === 'pending' && (
                    <div className="dispute-actions">
                      <button
                        type="button"
                        onClick={() => onResolveDispute(order.id, 'refund')}
                        className="resolve-btn refund-btn"
                      >
                        Process Refund
                      </button>
                      <button
                        type="button"
                        onClick={() => onResolveDispute(order.id, 'replacement')}
                        className="resolve-btn reorder-btn"
                      >
                        Approve Replacement
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
